// Resolves the PDP "back to search results" link from the referrer on the
// client, so the server-rendered fragment stays free of per-request data and
// can be shared across the visitor PDP cache.
//
// The referrer is browser-controlled, so it must be validated: only a
// same-origin textbooks path is accepted, and only its relative form is used.
// Otherwise a crafted referrer (e.g. https://evil.example/textbooks/...) could
// turn this into an off-site (phishing) link.
// The SRP route is /textbooks(/...), optionally prefixed with a single locale
// segment (e.g. /en-gb/textbooks). Match textbooks as a whole leading path
// segment — not a substring — so lookalikes such as /textbooks-malicious or
// /foo/textbooks/bar are rejected.
const SRP_PATH = /^\/(?:[a-z]{2}(?:-[a-z0-9]+)?\/)?textbooks(?:\/|$)/i

export const safeSearchResultsHref = (referrerString, origin) => {
  let referrer

  try {
    referrer = new URL(referrerString)
  } catch {
    return null // empty or unparseable referrer
  }

  if (referrer.origin !== origin) return null
  if (!SRP_PATH.test(referrer.pathname)) return null

  return referrer.pathname + referrer.search + referrer.hash
}

export const initBackToSearchResults = () => {
  const href = safeSearchResultsHref(document.referrer, window.location.origin)
  if (!href) return

  const container = document.getElementById('pdp-back-to-search-results')
  const link = document.getElementById('pdp-back-to-search-results-link')
  if (!container || !link) return

  link.setAttribute('href', href)
  container.style.display = ''
}
